export default "__VITE_ASSET__Da93786q__"